var React = require('react');

function EasyLangInline (props) {
    return React.createElement("path",props);
}

EasyLangInline.defaultProps = {"d":"M12,9.651373c2.21,0,4-1.79,4-4s-1.79-4-4-4s-4,1.79-4,4S9.79,9.651373,12,9.651373z M12,3.651373\n\tc1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S10.9,3.651373,12,3.651373z M12,12.201373c-2.36-2.2-5.52-3.55-9-3.55v11\n\tc3.48,0,6.64,1.35,9,3.549999c2.36-2.189999,5.52-3.549999,9-3.549999v-11C17.52,8.651373,14.36,10.001373,12,12.201373z\n\t M19,17.781372c-2.530001,0.34-4.93,1.300001-7,2.820002c-2.06-1.52-4.47-2.490002-7-2.83v-6.950001c2.1,0.38,4.05,1.35,5.64,2.83\n\tl1.36,1.28l1.36-1.27c1.59-1.48,3.54-2.45,5.64-2.83V17.781372L19,17.781372z"};

module.exports = EasyLangInline;

EasyLangInline.default = EasyLangInline;
